module.exports = __webpack_public_path__ + "static/img/arrow-up-filling.f1d47ca4.png";